import React, { Component } from "react";
import { Row, Col, Card, CardBody, Label, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

// Table data

const products = [
  {
    id: 1,
    factoryName: "USER0000321",
    departmentName: "Grader",
    timeShift: "Shift 1",
    userName: "Jon Done",
    accept: "15",
    hpht: "05",
    lpht: "03",
    real: "07",
    jiram: "19",
    total: "15",
  },
  {
    id: 2,
    factoryName: "USER0000321",
    departmentName: "Filler",
    timeShift: "Shift 1",
    userName: "Jon Done",
    accept: "15",
    hpht: "05",
    lpht: "03",
    real: "07",
    jiram: "19",
    total: "15",
  },
  {
    id: 3,
    factoryName: "USER0000321",
    departmentName: "Machine Operator",
    timeShift: "Shift 3",
    userName: "Jon Done",
    accept: "15",
    hpht: "05",
    lpht: "03",
    real: "07",
    jiram: "19",
    total: "15",
  },
  {
    id: 4,
    factoryName: "USER0000321",
    departmentName: "Boil Man",
    timeShift: "Shift 4",
    userName: "Jon Done",
    accept: "15",
    hpht: "05",
    lpht: "03",
    real: "07",
    jiram: "19",
    total: "15",
  },
];

class ActivePersonStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      productData: products,
    };
  }

  render() {
    const columns = [
      {
        dataField: "id",
        text: "#",
        sort: true,
      },
      {
        dataField: "factoryName",
        text: `${this.props.t("Factory Name")}`,
        sort: true,
      },
      {
        dataField: "departmentName",
        text: "Department Name",
        sort: true,
      },
      {
        dataField: "timeShift",
        text: "Time Shift",
        sort: true,
      },
      {
        dataField: "userName",
        text: `${this.props.t("Name")}`,
        sort: true,
      },
      {
        dataField: "accept",
        text: "Accept",
        sort: true,
      },
      {
        dataField: "hpht",
        text: "CVD",
        sort: true,
      },
      {
        dataField: "lpht",
        text: "LPHT",
        sort: true,
      },
      {
        dataField: "real",
        text: "REAL",
        sort: true,
      },
      {
        dataField: "jiram",
        text: "JIRAM",
        sort: true,
      },
      {
        dataField: "total",
        text: "Total",
        sort: true,
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: products.length, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "admin-report";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.productData}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.productData}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              selectFectory:
                                (this.state && this.state.selectFectory) || "",
                              selectDepartment:
                                (this.state && this.state.selectDepartment) ||
                                "",
                              userName:
                                (this.state && this.state.userName) || "",
                            }}
                            validationSchema={Yup.object().shape({
                              attachment: Yup.mixed()
                                .nullable()
                                .notRequired()
                                .test(
                                  "FILE_SIZE",
                                  "Uploaded file is too big.",
                                  value =>
                                    !value || (value && value.size <= FILE_SIZE)
                                )
                                .test(
                                  "FILE_FORMAT",
                                  "Uploaded file has unsupported format.",
                                  value =>
                                    !value ||
                                    (value &&
                                      SUPPORTED_FORMATS.includes(value.type))
                                ),
                              selectFectory: Yup.string().required(
                                "This value is required"
                              ),
                              selectDepartment: Yup.string().required(
                                "This value is required"
                              ),
                              userName: Yup.string().required(
                                "This value is required"
                              ),
                            })}
                            onSubmit={values => {
                              console.log(values);
                            }}
                          >
                            {({ errors, status, touched, values }) => (
                              <Form className="needs-validation">
                                <div className="pt-3">
                                  <div className="row">
                                    <div>
                                      <h4 className="text-black px-3 fw-bold mb-4">
                                        Active Person Stock
                                      </h4>
                                    </div>
                                    <div className="col-xl-8 col-12">
                                      <CardBody>
                                        <Row>
                                          <div className="mb-3 row">
                                            <Label
                                              htmlFor="selectFectory"
                                              className="col-md-3 col-form-label"
                                            >
                                              <h5 className="text-secondary fw-bold">
                                                Select Factory
                                              </h5>
                                            </Label>
                                            <div className="col-md-9">
                                              <Field
                                                className={
                                                  "form-control form-select fs-5" +
                                                  (errors.selectFectory &&
                                                  touched.selectFectory
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                type="text"
                                                name="selectFectory"
                                                placeholder="JANGAD0000123"
                                                as="select"
                                              >
                                                <option disabled value="">
                                                  select
                                                </option>
                                                <option value="1">
                                                  Factory Unit 1
                                                </option>
                                                <option value="2">
                                                  Factory Unit 2
                                                </option>
                                                <option value="3">
                                                  Factory Unit 3
                                                </option>
                                                <option value="4">
                                                  Factory Unit 4
                                                </option>
                                              </Field>
                                              <ErrorMessage
                                                name="selectFectory"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </div>
                                          </div>
                                          <div className="mb-3 row">
                                            <Label
                                              htmlFor="selectDepartment"
                                              className="col-md-3 col-form-label"
                                            >
                                              <h5 className="text-secondary fw-bold">
                                                Select Department
                                              </h5>
                                            </Label>
                                            <div className="col-md-9">
                                              <Field
                                                className={
                                                  "form-control form-select fs-5" +
                                                  (errors.selectDepartment &&
                                                  touched.selectDepartment
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                type="text"
                                                name="selectDepartment"
                                                placeholder="JANGAD0000123"
                                                as="select"
                                              >
                                                <option disabled value="">
                                                  select
                                                </option>
                                                <option value="1">
                                                  Grading department
                                                </option>
                                                <option value="2">
                                                  Grading department
                                                </option>
                                                <option value="3">
                                                  Grading department
                                                </option>
                                                <option value="4">
                                                  Grading department
                                                </option>
                                              </Field>
                                              <ErrorMessage
                                                name="selectDepartment"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </div>
                                          </div>
                                          <div className="mb-3 row">
                                            <Label
                                              htmlFor="userName"
                                              className="col-md-3 col-form-label"
                                            >
                                              <h5 className="text-secondary fw-bold">
                                                Select {this.props.t("User Name")}
                                              </h5>
                                            </Label>
                                            <div className="col-md-9">
                                              <Field
                                                className={
                                                  "form-control form-select fs-5" +
                                                  (errors.userName &&
                                                  touched.userName
                                                    ? " is-invalid"
                                                    : "")
                                                }
                                                type="text"
                                                name="userName"
                                                placeholder="JANGAD0000123"
                                                as="select"
                                              >
                                                <option disabled value="">
                                                  select
                                                </option>
                                                <option value="1">
                                                  Grader 1
                                                </option>
                                                <option value="2">
                                                  Grader 2
                                                </option>
                                                <option value="3">
                                                  Grader 3
                                                </option>
                                                <option value="4">
                                                  Grader 4
                                                </option>
                                              </Field>
                                              <ErrorMessage
                                                name="userName"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </div>
                                          </div>
                                        </Row>
                                      </CardBody>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                      <div className="px-4">
                                        <div className="row border-gray py-3">
                                          <div className="col-md-5 col-12 pt-2">
                                            <h5>{this.props.t("Contact Person")} :</h5>
                                          </div>
                                          <div className="col-md-7 col-12 pt-2">
                                            <h5>Brooklyn Simmons</h5>
                                          </div>
                                          <div className="col-md-5 col-12 pt-2">
                                            <h5>{this.props.t("Mobile no.1")} : </h5>
                                          </div>
                                          <div className="col-md-7 col-12 pt-2">
                                            <h5>+91 (132)(564)(9872)</h5>
                                          </div>
                                          <div className="col-md-5 col-12 pt-2">
                                            <h5>{this.props.t("Mobile no.2")} : </h5>
                                          </div>
                                          <div className="col-md-7 col-12 pt-2">
                                            <h5>+91 (132)(564)(9872)</h5>
                                          </div>
                                          <div className="col-md-5 col-12 pt-2">
                                            <h5>{this.props.t("Email Address")} : </h5>
                                          </div>
                                          <div className="col-md-7 col-12 pt-2">
                                            <h5>xyzdiamond12@gmail.com</h5>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Form>
                            )}
                          </Formik>

                          <CardBody>
                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">{this.props.t('Show')}</p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">{this.props.t('entries')}</p>
                                </div>
                              </div>
                            </div>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>{this.props.t('Showing')} 1 - 10 of 350</h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default ActivePersonStock;
